/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAttachmentDto } from './GetAttachmentDto';
import {
    GetAttachmentDtoFromJSON,
    GetAttachmentDtoFromJSONTyped,
    GetAttachmentDtoToJSON,
} from './GetAttachmentDto';
import type { GetManualTestDto } from './GetManualTestDto';
import {
    GetManualTestDtoFromJSON,
    GetManualTestDtoFromJSONTyped,
    GetManualTestDtoToJSON,
} from './GetManualTestDto';

/**
 * 
 * @export
 * @interface GetManualDto
 */
export interface GetManualDto {
    /**
     * 
     * @type {string}
     * @memberof GetManualDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetManualDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetManualDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<GetManualTestDto>}
     * @memberof GetManualDto
     */
    manualTests?: Array<GetManualTestDto> | null;
    /**
     * 
     * @type {Array<GetAttachmentDto>}
     * @memberof GetManualDto
     */
    attachments?: Array<GetAttachmentDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetManualDto
     */
    active?: boolean | null;
}

/**
 * Check if a given object implements the GetManualDto interface.
 */
export function instanceOfGetManualDto(value: object): value is GetManualDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetManualDtoFromJSON(json: any): GetManualDto {
    return GetManualDtoFromJSONTyped(json, false);
}

export function GetManualDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetManualDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'manualTests': json['manualTests'] == null ? undefined : ((json['manualTests'] as Array<any>).map(GetManualTestDtoFromJSON)),
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(GetAttachmentDtoFromJSON)),
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function GetManualDtoToJSON(value?: GetManualDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'manualTests': value['manualTests'] == null ? undefined : ((value['manualTests'] as Array<any>).map(GetManualTestDtoToJSON)),
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(GetAttachmentDtoToJSON)),
        'active': value['active'],
    };
}

